export const state = {
  cycleProduction: undefined,
  cycleProductions: [],

}